/**
 * exportView.js - the CSV rows for exactly what is on screen (Sharif,
 * 10/9/26: "when they choose to export, it exports what is on their
 * screen"): the visible columns in their on-screen order, the rows the
 * table shows (filters, search and sort already applied by the caller), and
 * the totals row last when the table shows one. PURE.
 *
 *   cols        the visible column defs (Tasks / Comments carry noExport)
 *   rows        the filtered, sorted rows
 *   valueOf     (row, colId) -> the cell's export text
 *   totals      { colId: text } for the columns that have a total, or null
 *   totalsLabel the words for the totals row ("Won totals (12 records)")
 */
export function exportViewRows(cols, rows, valueOf, { totals = null, totalsLabel = 'Totals' } = {}) {
  const out = cols.filter((c) => !c.noExport);
  const key = (c) => c.exportLabel || c.label;
  const list = rows.map((r) => Object.fromEntries(out.map((c) => [key(c), valueOf(r, c.col)])));
  if (totals && list.length) {
    let labelled = false;
    list.push(
      Object.fromEntries(
        out.map((c) => {
          if (c.col in totals) return [key(c), totals[c.col]];
          if (!labelled) {
            labelled = true;
            return [key(c), totalsLabel];
          }
          return [key(c), ''];
        })
      )
    );
  }
  return list;
}
